/**
 * Récupère la première occurrence d'un paramètre d'URL
 * sans appliquer decodeURIComponent, decodeURI, ni remplacement des +.
 * @param {string} urlStr - L'URL complète (ou une query string)
 * @param {string} key - Nom du paramètre
 * @returns {string|null} Valeur brute (inchangée), ou null si absente
 */

// utils/urlRawParams.js
// ⚡ Extraction de paramètres d'URL sans décodage — pour préserver les chaînes Base64 intactes.

function _extractQuery(urlStr) {
  if (typeof urlStr !== 'string') return '';
  const qIdx = urlStr.indexOf('?');
  if (qIdx === -1) return '';
  let q = urlStr.slice(qIdx + 1);
  const hIdx = q.indexOf('#');
  if (hIdx !== -1) q = q.slice(0, hIdx);
  return q;
}

export function getParamRaw(urlStr, key) {
  const q = _extractQuery(urlStr);
  if (!q) return null;
  const esc = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const re = new RegExp('(?:^|&)' + esc + '=([^&]*)');
  const m = re.exec(q);
  return m ? m[1] : null; // valeur brute
}